import Head from 'next/head'

function MetaData(): JSX.Element {
  return (
    <Head>
      <title>Daftar / Register | Ralali.com</title>
      <meta
        name="description"
        content="Belum punya akun Ralali? Yuk segera daftar dan nikmati kemudahan belanja kebutuhan bisnis kamu hanya di Ralali.com."
      />
      <meta name="keywords" content="daftar ralali" />
    </Head>
  )
}

export default MetaData
